var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex tw-items-center tw-gap-2 tw-cursor-pointer",on:{"click":_vm.downloadData}},[_c('fa',{class:_vm.iconClass,attrs:{"icon":_vm.icon}}),_c('span',{class:_vm.textClass},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }